import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=e74b75f6&scoped=true&"
import script from "./Module.vue?vue&type=script&lang=js&"
export * from "./Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74b75f6",
  null
  
)

component.options.__file = "Module.vue"
export default component.exports